/**
 * FancyboxController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Image.FancyboxController = function () {
  var $fancybox = $('.js-fancybox');
  var $gallery = $('.js-fancybox-gallery');
  var $bannerGenerator = $('.js-bannerGenerator');
  var loadingHtml = ('<div class="spinner spinner--fancybox"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div>');

  $fancybox.fancybox({
    idleTime: 9999,
    spinnerTpl: loadingHtml,
    buttons: [
      'zoom',
      'fullScreen',
      'thumbs',
      'close'
    ],
    i18n: {
      en: {
        CLOSE: 'Close',
        NEXT: 'Next',
        PREV: 'Previous',
        ERROR: 'The requested content cannot be loaded. <br/> Please try again later.',
        PLAY_START: 'Start slideshow',
        PLAY_STOP: 'Pause slideshow',
        FULL_SCREEN: 'Full screen',
        THUMBS: 'Thumbnails'
      },
      de: {
        CLOSE: 'Schliessen',
        NEXT: 'Weiter',
        PREV: 'Zurück',
        ERROR: 'Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.',
        PLAY_START: 'Diaschau starten',
        PLAY_STOP: 'Diaschau beenden',
        FULL_SCREEN: 'Vollbild',
        THUMBS: 'Vorschaubilder'
      }
    }
  });

  $gallery.fancybox({
    spinnerTpl: loadingHtml,
    arrows: true,
    infobar: true,
    idleTime: 9999,
    transitionEffect: 'slide',
    thumbs: {
      autoStart: true
    },
    buttons: [
      'slideShow',
      'fullScreen',
      'thumbs',
      'close'
    ],
    i18n: {
      en: {
        CLOSE: 'Close',
        NEXT: 'Next',
        PREV: 'Previous',
        ERROR: 'The requested content cannot be loaded. <br/> Please try again later.',
        PLAY_START: 'Start slideshow',
        PLAY_STOP: 'Pause slideshow',
        FULL_SCREEN: 'Full screen',
        THUMBS: 'Thumbnails'
      },
      de: {
        CLOSE: 'Schliessen',
        NEXT: 'Weiter',
        PREV: 'Zurück',
        ERROR: 'Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.',
        PLAY_START: 'Diaschau starten',
        PLAY_STOP: 'Diaschau beenden',
        FULL_SCREEN: 'Vollbild',
        THUMBS: 'Vorschaubilder'
      }
    },
    clickContent: function () {
      return false;
    },
    mobile: {
      clickContent: function () {
        return false;
      },
      clickSlide: function () {
        return false;
      },
      dblclickContent: function () {
        return 'zoom';
      },
      dblclickSlide: function () {
        return 'zoom';
      }
    },
    afterLoad: function () {
      var height;
      if ($('.fancybox-container').hasClass('fancybox-show-caption')) {
        height = $(' .fancybox-caption-wrap').height();
      } else {
        height = 0;
      }
      $('.fancybox-stage').css('bottom', height);
    }
  });

  $bannerGenerator.fancybox({
    spinnerTpl: loadingHtml,
    smallBtn: true,
    toolbar: false,
    i18n: {
      en: {
        CLOSE: 'Close',
        NEXT: 'Next',
        PREV: 'Previous',
        ERROR: 'The requested content cannot be loaded. <br/> Please try again later.',
        PLAY_START: 'Start slideshow',
        PLAY_STOP: 'Pause slideshow',
        FULL_SCREEN: 'Full screen',
        THUMBS: 'Thumbnails'
      },
      de: {
        CLOSE: 'Schliessen',
        NEXT: 'Weiter',
        PREV: 'Zurück',
        ERROR: 'Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.',
        PLAY_START: 'Diaschau starten',
        PLAY_STOP: 'Diaschau beenden',
        FULL_SCREEN: 'Vollbild',
        THUMBS: 'Vorschaubilder'
      }
    }
  });
};
